module.exports = __webpack_public_path__ + "static/media/geo-02.848fac84.svg";